"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GridSidePaneView = exports.GridCenterView = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactUse = require("react-use");
var _reactUi = require("@100mslive/react-ui");
var _FirstPersonDisplay = require("./FirstPersonDisplay");
var _VideoList = _interopRequireDefault(require("./VideoList"));
var _Image = require("./Image");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var MAX_TILES_FOR_MOBILE = 4;

/**
 * the below variables are for showing webinar etc. related image if required on certain meeting urls
 */
var webinarProps = JSON.parse(process.env.REACT_APP_WEBINAR_PROPS || "{}");
var eventRoomIDs = (webinarProps === null || webinarProps === void 0 ? void 0 : webinarProps.ROOM_IDS) || [];
var eventsImg = (webinarProps === null || webinarProps === void 0 ? void 0 : webinarProps.IMAGE_FILE) || ""; // the image to show in center
// the link to navigate to when user clicks on the image
var webinarInfoLink = (webinarProps === null || webinarProps === void 0 ? void 0 : webinarProps.LINK_HREF) || "https://100ms.live/";

// The center of the screen shows bigger tiles
var GridCenterView = function GridCenterView(_ref) {
  var peers = _ref.peers,
    maxTileCount = _ref.maxTileCount;
  var mediaQueryLg = _reactUi.config.media.md;
  var limitMaxTiles = (0, _reactUse.useMedia)(mediaQueryLg);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
      css: {
        flex: "1 1 0",
        height: "100%",
        mx: "$8",
        "@md": {
          flex: "2 1 0"
        }
      },
      children: peers && peers.length > 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_VideoList["default"], {
        peers: peers,
        maxTileCount: limitMaxTiles ? MAX_TILES_FOR_MOBILE : maxTileCount
      }) : eventRoomIDs.some(function (id) {
        return window.location.href.includes(id);
      }) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
        css: {
          display: "grid",
          placeItems: "center",
          size: "100%",
          p: "$12"
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
          href: webinarInfoLink,
          target: "_blank",
          rel: "noreferrer",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Image.Image, {
            css: {
              p: "$4",
              boxShadow: "$sm"
            },
            alt: "Event template",
            src: eventsImg
          })
        })
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_FirstPersonDisplay.FirstPersonDisplay, {})
    })
  });
};

// Side pane shows smaller tiles
exports.GridCenterView = GridCenterView;
var GridSidePaneView = function GridSidePaneView(_ref2) {
  var peers = _ref2.peers;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Flex, {
    direction: "column",
    css: {
      flex: "0 0 20%",
      mx: "$8",
      "@lg": {
        flex: "0 0 25%"
      },
      "@md": {
        flex: "1 1 0"
      }
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Flex, {
      css: {
        flex: "1 1 0"
      },
      align: "end",
      children: peers && peers.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_VideoList["default"], {
        peers: peers,
        maxColCount: 2
      })
    })
  });
};
exports.GridSidePaneView = GridSidePaneView;